import React from 'react';
import { Show, SimpleShowLayout, TextField, ImageField, TopToolbar, ListButton, WithRecord } from 'react-admin';
import { Grid, Typography, Box, Divider, Chip, Card, Button } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';

const ProductShow = () => (
    <Show actions={<TopToolbar><ListButton label="Back" /></TopToolbar>}>
        <SimpleShowLayout>
            <Box p={3}>
                <Grid container spacing={5}>
                    <Grid item xs={12} md={5}>
                        <Card elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', border: '1px solid #eee' }}>
                            <ImageField source="image" sx={{ '& img': { width: '100%', height: 'auto' } }} />
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}><TextField source="title" /></Typography>
                        <Typography variant="h5" color="success.main" sx={{ mb: 3, fontWeight: 700 }}><TextField source="price" /> JOD</Typography>
                        <Divider sx={{ mb: 3 }} />
                        <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7 }}><TextField source="description" /></Typography>
                        
                        <Grid container spacing={2} mb={4}>
                            <Grid item xs={4}><Typography variant="caption" sx={{ fontWeight: 'bold' }}>COLORS</Typography><TextField source="colors" /></Grid>
                            <Grid item xs={4}><Typography variant="caption" sx={{ fontWeight: 'bold' }}>SIZES</Typography><TextField source="sizes" /></Grid>
                            <Grid item xs={4}><Typography variant="caption" sx={{ fontWeight: 'bold' }}>CATEGORY</Typography><Chip label={<TextField source="category" />} color="primary" variant="outlined" /></Grid>
                        </Grid>
                        
                        <Divider sx={{ mb: 3 }} />

                        {/* هذا الجزء هو الذي يحل مشكلة الرجوع للهوم */}
                        <WithRecord render={record => (
                            <Box mt={2}>
                                <Typography variant="caption" display="block" sx={{ fontWeight: 'bold', mb: 1, color: 'text.secondary' }}>SOURCE LINK</Typography>
                                <Button 
                                    variant="contained" 
                                    startIcon={<LaunchIcon />}
                                    component="a"
                                    href={record.url} // هنا نستخدم الرابط الموجود في الشيت لكل منتج
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 'bold', backgroundColor: '#1e3a8a' }}
                                >
                                    Visit Product Site
                                </Button>
                            </Box>
                        )} />
                    </Grid>
                </Grid>
            </Box>
        </SimpleShowLayout>
    </Show>
);

export default ProductShow;